import { ApiService, AuthenticationService } from '@app/core';
import { JwtService } from '@app/core/services/jwt.service';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  constructor(private apiService: ApiService,
    private jwtService: JwtService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinnerService: Ng4LoadingSpinnerService,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef

  ) {
  }
  ngAfterViewInit(): void {
    if (this.tabs) {
      this.tabs.select(this.selectedTab);
      this.cdref.detectChanges();
    }
  }

  userName: string;
  dataData: string;
  lastLogin: string;
  Role: string = this.jwtService.getUserRole();
  selectedTab: string;
  selectedID : string;
  selectedAction:string;
  pageheading = "New Notification";


  @ViewChild('tabs') tabs: NgbTabset;

  ngOnInit() {
    this.selectedID=null;
    this.selectedAction=null;
    
    this.route.queryParams.subscribe(params => {
      
      this.selectedAction=params['action'];
      this.selectedID=params['id'];
      this.selectedTab = params['tab'];
    });
      this.checkLink(this.selectedAction);

    this.spinnerService.show();
  }


   checkLink(invokedFrom: string) {
  if (invokedFrom === 'view') {
    this.pageheading = "View Notification";
  } else if (invokedFrom === 'edit') {
    this.pageheading = "Edit Notification";
  } else {
    this.pageheading = "New Notification";
  }
}

  onTabChange($event: any) {
    //this.selectedID=null;
    //this.selectedAction=null;
    var clickedTab = $event.nextId.toString();
    if(clickedTab=="Notifications" || clickedTab == "Dashboard" ){
      this.pageheading = "New Notification";
    }
    // this.route.queryParams.subscribe(params => {
    //   this.selectedAction=params['action'];
    //  this.selectedID=params['id'];
    //   //this.selectedTab = params['tab'];
    // });
    // console.log(clickedTab);
    // console.log(this.route);

    // console.log("/home/?tab=" + $event.nextId);
    if((this.selectedAction == "view" || this.selectedAction == "edit") && clickedTab=="Notification"){ 
      this.router.navigate(['/home'], { queryParams:{ tab: clickedTab, id: this.selectedID, action: this.selectedAction } });
    }else {
    this.router.navigate(['/home'], { queryParams: { tab: clickedTab } });
  }

  }
}
